import React from "react";
import { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import Languages from "../../../../Components/Atoms/Shared/language/Language";
import CCrud from "../../../../Components/Molecules/General/Crud/CCrud";
import "../../../../Components/Atoms/Shared/Styles/list-page.css";
import { initialValues, structure, validationSchema } from "./structure";
import AddIcon from "@mui/icons-material/Add";
import {
  createLanguageFluency,
  updateLanguageFluency,
} from "../../../../Contexts/APIs/Fluency Level/FluencyLevel";
import "./FluencyLanguage.css";

const FluencyLanguageTemplate = ({
  setFilterObj,
  data,
  openDeleteModal,
  setOpenDeleteModal,
  handleDeleteRequest,
  count,
  paginationPage,
  setPaginationPage,
  handlePageChange,
  rowData,
  details,
  breadcrumbs,
  roles,
}) => {
  let [searchParams, setSearchParams] = useSearchParams();
  const index = searchParams.get("index");

  const id = searchParams.get("id");
  const navigate = useNavigate();
  const [supportedLang, setSupportedLang] = useState("en");

  const handelSubmit = (data, formik) => {
    const action = () => {
      searchParams.delete("id");
      searchParams.delete("type");
      searchParams.delete("index");
      navigate("/predefined-lookups/fluency-languages");
      formik?.resetForm();
    };

    if (index) {
      updateLanguageFluency({
        id,
        data: { language_fluency_level: data },
        action,
      });
    } else {
      createLanguageFluency({
        data: { language_fluency_level: data },
        action,
      });
    }
  };

  const handleApplyFilterMenu = (obj) => {
    setFilterObj((prev) => {
      return { ...prev, ...obj, page_number: 1 };
    });
    setPaginationPage(1);
  };
  const handleResetFilterMenu = () => {
    setFilterObj({
      page_size: 10,
      page_number: 1,
      keyword: "",
      sort_by: "id",
    });
    setPaginationPage(1);
  };
  const actionsList = ({ id, index, details }) => {
    return [
      {
        condition: () => {
          if (roles?.can_read && roles?.can_update) {
            return true;
          } else {
            return false;
          }
        },
        click: () => {
          navigate(`?type=form&id=${id}&index=${index}`);
        },
        text: "Edit",
      },
      {
        condition: () => {
          if (roles?.can_read && roles?.can_delete) {
            return true;
          } else {
            return false;
          }
        },
        click: () => {
          setOpenDeleteModal(true);
        },
        text: "Delete",
      },
    ];
  };
  return (
    <CCrud
      table={{
        list: data,
        openDeleteModal: openDeleteModal,
        setOpenDeleteModal: setOpenDeleteModal,
        rowData: rowData,
        actionsList,
        listTitle: "Language fluency levels",
        emptyListMsg: "There are no fluency level",
        details: {
          navigatePath: "/predefined-lookups/fluency-languages",
          statusField: null,
          hideStatus: null,
        },
        columns: [
          { accessor: "id", Header: "Id" },
          { accessor: "name", Header: "Name" },
          { accessor: "created_at_data", Header: "Created at" },
          { accessor: "updated_at_data", Header: "Updated at" },
          { accessor: "Actions", Header: "Actions" },
        ],
        isFilter: false,
        isSearch: false,
        isChecked: false,
        isSort: false,
        total_count: count,
        setFilterObj,
        handleApplyFilterMenu: handleApplyFilterMenu,
        handleResetFilterMenu: handleResetFilterMenu,
        createBtnTitle: "Add new language fluency level",
        createBtnFun:
          roles?.can_read && roles?.can_create
            ? () => navigate("?type=form")
            : null,
        CreateBtnIcon: AddIcon,
        createBtnClass: "add-organization-button",
        className: "organization-table language-fluency-table",
        paginationPage: paginationPage,
        setPaginationPage: setPaginationPage,
        handlePageChange,
        openDeleteModal: openDeleteModal,
        setOpenDeleteModal: setOpenDeleteModal,
        handleDeleteRequest,
      }}
      form={{
        structure: () => structure(supportedLang),
        validationSchema: () => validationSchema(supportedLang),
        initialValues: !index ? {} : initialValues(details, supportedLang),
        onSubmit: handelSubmit,
        setSupportedLang: setSupportedLang,
        className: {
          form: "flow-form language-fluency-form",
          actionButton: "flow-form-buttons",
        },
        handleLanguage: <Languages setLanguage={setSupportedLang} />,
        breadcrumbs: breadcrumbs,
        title: index
          ? "Edit language fluency level"
          : "Add new language fluency level",
        submitTitle: index === null ? "Add" : "Save changes",
      }}
    />
  );
};

export default FluencyLanguageTemplate;
